import { useTranslation } from "react-i18next"

const FakeDecisionQuestions = () => {
    const { t } = useTranslation()
    return (
        <div className="bill-summary p-3 mb-4">
            <div className="row flex-column">
                <div className="row col-12">
                    <div className="text-gray-600 fw-bolder mb-3 col-10">
                        {t("request-print-q1")}
                    </div>
                    <div className="fw-bold col-2">{t("no")}</div>
                </div>
                <div className="row col-12">
                    <div className="text-gray-600 fw-bolder mb-3 col-10">
                        {t("request-print-q2")}
                    </div>
                    <div className="fw-bold col-2">{t("no")}</div>
                </div>
                <div className="row col-12">
                    <div className="text-gray-600 fw-bolder mb-3 col-10">
                        {t("request-print-q3")}
                    </div>
                    <div className="fw-bold col-2">{t("yes")}</div>
                </div>
            </div>
        </div>
    )
}

export default FakeDecisionQuestions